import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import { AvaEntity } from '../../entities/ava.entity';
import { getLatestUpdatedAt } from '../../helper/reducer.helper';
import { AvaActions } from '../actions/ava.actions';

export const AVA_FEATURE_KEY = 'ava';

export interface AvaState extends EntityState<AvaEntity> {
    fetched: boolean;
    latestUpdatedAt: Date | null;
}

const adapter = createEntityAdapter<AvaEntity>({
    selectId: (Entity) => Entity.Id,
});

const initialState: AvaState = adapter.getInitialState({
    fetched: false,
    latestUpdatedAt: null,
});

/* ############# */
/* ## REDUCER ## */
/* ############# */

export const avaReducer = createReducer(
    initialState,
    on(AvaActions.loadSuccess, (state, { Payload }) =>
        adapter.setMany(Payload, {
            ...state,
            latestUpdatedAt: getLatestUpdatedAt(Payload, state.latestUpdatedAt),
            fetched: true,
        }),
    ),
    on(AvaActions.changeSuccess, (state, { Payload }) => adapter.setOne(Payload, state)),
    on(AvaActions.addSuccess, (state, { Payload }) => adapter.addOne(Payload, state)),
    on(AvaActions.deleteSuccess, (state, { Payload }) => adapter.removeOne(Payload, state)),
);

/* ############### */
/* ## SELECTORS ## */
/* ############### */

const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors();

export const selectAllAva = selectAll;
export const selectAvaEntities = selectEntities;

export const selectAvaFetched = (state: AvaState) => state.fetched;
export const selectAvaLatestUpdatedAt = (state: AvaState) => state.latestUpdatedAt;
